// Photos of people are found by FILE NAME: put "manish-d-warekar.jpg" in
// src/assets/people/ and Manish D. Warekar's card shows it, with no code change.
// The name is lower-cased and every run of other characters becomes a hyphen:
//   "Dr K. S. Mhaskar" -> dr-k-s-mhaskar.jpg
// .jpg, .jpeg, .png and .webp all work. Square-ish headshots crop best.
const files = import.meta.glob<string>('@/assets/people/*.{jpg,jpeg,png,webp}', { eager: true, import: 'default' });

export const slugify = (name: string) =>
  name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

export function portraitFor(name: string): string | undefined {
  const wanted = slugify(name);
  const hit = Object.entries(files).find(([path]) => (path.split('/').pop() ?? '').replace(/\.\w+$/, '') === wanted);
  return hit?.[1];
}
